<template>
  <div class="mobile-input-number">
    <div class="button" @click="onReduce">
      <i class="iconfont icon-subtract-line" />
    </div>

    <input v-model.number="num" class="input" type="number" @change="onChange" />

    <div class="button" @click="onIncrease">
      <i class="iconfont icon-a-add-line1" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: false,
      default: 0
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      num: this.value
    }
  },
  methods: {
    onReduce() {
      if (this.num === this.min) {
        return
      }
      this.num -= 1
      this.$emit('change', this.num)
    },

    onChange(event) {
      let num = Number.parseInt(event.target.value)
      if (!num) {
        num = 0
      }
      if (num <= this.min) {
        this.num = this.min
      } else if (num >= this.max) {
        this.num = this.max
      } else {
        this.num = num
      }
      this.$emit('change', this.num)
    },

    onIncrease() {
      if (this.num === this.max) {
        return
      }
      this.num += 1
      this.$emit('change', this.num)
    },

    /**
     * 设置输入框的值
     *
     * @param {Number} value 需要设置的值
     */
    setNum(value) {
      this.num = value
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-input-number {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .button {
    display: flex;
    width: 0.3rem;
    height: 0.3rem;
    align-items: center;
    justify-content: center;
    border: 0.5px solid #b6b6b6;
    border-radius: 100%;
  }
  input {
    display: inline-block;
    color: #99c41c;
    width: 38px;
    height: 28px;
    text-align: center;
    border: none;
    outline: none;
  }
}
</style>
